class CustomSizeChart extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector(".custom-size--content");
    this.heading = this.querySelector(".custom-size--heading");
    this.closeButton = this.querySelector(".close");
    this.inchActButton = this.querySelector("#inch-act");
    this.cmActButton = this.querySelector("#cm-act");
    this.inchTable = this.querySelector("#inch-table");
    this.cmTable = this.querySelector("#cm-table");

    this.heading.addEventListener("click", () => {
      this.toggleModal();
    });

    this.closeButton.addEventListener("click", () => {
      this.hideModal();
    });

    this.inchActButton.addEventListener("click", () => {
      this.toggleTables("inch");
    });

    this.cmActButton.addEventListener("click", () => {
      this.toggleTables("cm");
    });
  }

  toggleModal() {
    if (this.content.classList.contains("hidden-md")) {
      this.content.classList.remove("hidden-md");
      this.content.classList.add("block");
      document.body.style.overflow = "hidden";
    } else {
      this.hideModal();
    }
  }

  hideModal() {
    this.content.classList.add("hidden-md");
    document.body.style.overflow = "auto";
  }

  toggleTables(unit) {
    if (unit === "inch") {
      this.inchTable.style.display = "block";
      this.cmTable.style.display = "none";
      this.inchActButton.classList.add("sizes-active");
      this.cmActButton.classList.remove("sizes-active");
      this.inchTable.classList.add("active");
      this.cmTable.classList.remove("active");
    } else if (unit === "cm") {
      this.cmTable.style.display = "block";
      this.inchTable.style.display = "none";
      this.cmActButton.classList.add("sizes-active");
      this.inchActButton.classList.remove("sizes-active");
      this.cmTable.classList.add("active");
      this.inchTable.classList.remove("active");
    }
  }
}

customElements.define("custom-size-chart", CustomSizeChart);
